import {Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';

@Component({
  selector: 'app-element-slide-toggle',
  templateUrl: './element-slide-toggle.component.html',
  styleUrls: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ElementSlideToggleComponent),
      multi: true,
    },
  ],
})
export class ElementSlideToggleComponent implements OnInit, OnChanges {

  @Input() qaAttr: string;
  @Input() label = 'default label';
  @Input() disabled = false;
  @Input() initialValue = false;
  @Output() valueChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  formControl: FormControl = new FormControl();

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = (): void => {};

  ngOnInit() {
    this.formControl.setValue(this.initialValue);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.label && changes.label.currentValue) {
      const value = changes.label.currentValue || 'qa-slide-toggle';
      this.qaAttr = 'qa-' + value.replace(/ /g, '-').toLowerCase();
    }
    if (changes?.disabled) {
      if (this.disabled) {
        this.formControl.disable();
      }
      else {
        this.formControl.enable();
      }
    }
  }

  writeValue(value: any): void {
    this.formControl.setValue(value);
  }

  registerOnChange(onChange: (value: any) => void): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  onSlideToggleChange(event: MatSlideToggleChange): void {
    this.onChange(event?.checked);
    this.onTouched();
    this.valueChanged.emit(event?.checked);
  }

}
